var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",attrs:{"id":"app-wrapper","name":"top"}},[_c('site-masthead',{attrs:{"siteData":this.siteData}}),_c('router-view',{attrs:{"projectList":this.filteredProjectList,"imageSizes":this.siteData.imageSizes,"longBio":this.siteData.longBio,"bioPhoto":this.siteData.bioPhoto}}),_c('site-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }